// `search.page.tpl.html:877` — two checkboxes, each in its own bare `<div>`.
//
// The wrappers are unclassed and contribute nothing but a line break; they are reproduced
// because the section has no wrap element either, so these divs are what separates the two
// rows (see the `wrapClassName: undefined` note in the shell's section table).
import type { ReactElement } from 'react'
import { WooCheckbox } from '../common/WooCheckbox.tsx'

export interface ContactDetailsCriteria {
  hasEmailOnly?: boolean
  hasPhoneOnly?: boolean
}

export interface ContactDetailsSectionProps {
  criteria: ContactDetailsCriteria
  onChange?: (criteria: ContactDetailsCriteria) => void
}

export function ContactDetailsSection({ criteria, onChange }: ContactDetailsSectionProps): ReactElement {
  return (
    <>
      <div>
        {/* `hasEmailOnly` — "only candidates who have one", not "email is optional". */}
        <WooCheckbox
          checked={criteria.hasEmailOnly === true}
          onChange={(hasEmailOnly) => onChange?.({ ...criteria, hasEmailOnly })}
        >
          Has valid email
        </WooCheckbox>
      </div>
      <div>
        <WooCheckbox
          checked={criteria.hasPhoneOnly === true}
          onChange={(hasPhoneOnly) => onChange?.({ ...criteria, hasPhoneOnly })}
        >
          Has valid phone
        </WooCheckbox>
      </div>
    </>
  )
}
